import { useRef, useState, useEffect } from "react";
import useGetImages from "../useGetImages";

// --- Ürün Opsiyonları ---
const OPSIYON_API = 'https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/';
const normalizeText = (text) =>
  text.toLowerCase().replace(/ş/g, "s").replace(/ğ/g, "g").replace(/ü/g, "u")
    .replace(/ö/g, "o").replace(/ı/g, "i").replace(/ç/g, "c").trim();
const isNumericValue = (str) => {
  if (!str) return false;
  const cleaned = str.replace(",", ".").trim();
  return !isNaN(parseFloat(cleaned)) && isFinite(cleaned);
};
const NUTRITION_COLORS = ["#3B82F6","#F59E0B","#EF4444","#10B981","#8B5CF6","#EC4899","#14B8A6","#F97316"];
const NUTRITION_MAP = {
  kalo:{label:"Kalori",unit:"kcal"},ene:{label:"Enerji",unit:"kcal"},pro:{label:"Protein",unit:"g"},kar:{label:"Karbonhidrat",unit:"g"},
  sek:{label:"Şeker",unit:"g"},yag:{label:"Yağ",unit:"g"},doy:{label:"Doymuş Yağ",unit:"g"},tra:{label:"Trans Yağ",unit:"g"},
  lif:{label:"Lif",unit:"g"},tuz:{label:"Tuz",unit:"g"},sod:{label:"Sodyum",unit:"mg"},kol:{label:"Kolesterol",unit:"mg"},
  kals:{label:"Kalsiyum",unit:"mg"},dem:{label:"Demir",unit:"mg"},vit:{label:"Vitamin",unit:""},
};
const matchNutrition = (desc) => {
  const n = normalizeText(desc);
  if (n.includes("kcal") || n === "kal") return NUTRITION_MAP.kalo;
  const p4 = n.substring(0, 4);
  if (p4 === "kalo") return NUTRITION_MAP.kalo; if (p4 === "kals") return NUTRITION_MAP.kals;
  return NUTRITION_MAP[n.substring(0, 3)] || { label: desc, unit: "" };
};
const ALLERGEN_TR_MAP = {
  sut:"MILK","süt":"MILK",soya:"SOY",yumurta:"EGG",kabuklular:"CRUSTACEAN",susam:"SESAME",hardal:"MUSTARD",
  "yumusakçalar":"SHELLFISH",yumusakca:"SHELLFISH","aci bakla":"LUPINS","acı bakla":"LUPINS",kukurt:"SULFITES",
  sulfit:"SULFITES",kereviz:"CELERY",yerfistigi:"PEANUTS","yer fistigi":"PEANUTS",balik:"FISH","balık":"FISH","sert kabuklu":"NUTS",gluten:"GLUTEN",
};
const ALLERGEN_KEYS = ["MILK","SOY","EGG","CRUSTACEAN","SESAME","MUSTARD","SHELLFISH","LUPINS","SULFITES","CELERY","PEANUTS","FISH","NUTS","GLUTEN"];
const getAllergenType = (item) => {
  if (item.DESCRIPTION_ING) { const key = item.DESCRIPTION_ING.toUpperCase(); if (ALLERGEN_KEYS.includes(key)) return key; }
  const norm = normalizeText(item.DESCRIPTION);
  for (const [tr, eng] of Object.entries(ALLERGEN_TR_MAP)) { if (norm.includes(tr)) return eng; }
  return null;
};
const AllergenIcon = ({ type }) => {
  const icons = {
    MILK: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M8 2h8l1 5H7l1-5z"/><rect x="7" y="7" width="10" height="13" rx="2"/><path d="M10 12c0-1 1-2 2-2s2 1 2 2"/></svg>,
    SOY: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><ellipse cx="12" cy="12" rx="5" ry="8"/><path d="M12 4v16M7.5 8h9M7.5 16h9"/></svg>,
    EGG: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M12 3c-3.5 0-7 5-7 11a7 7 0 0014 0c0-6-3.5-11-7-11z"/></svg>,
    GLUTEN: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M12 22V6M12 6c-2-2-4-4-3-5s3 1 3 5M12 6c2-2 4-4 3-5s-3 1-3 5M12 11c-3-1-5-1-5 1s3 3 5 2M12 11c3-1 5-1 5 1s-3 3-5 2M12 16c-3-1-5-1-5 1s3 3 5 2M12 16c3-1 5-1 5 1s-3 3-5 2"/></svg>,
    FISH: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M2 12c3-4 7-6 12-6 2 0 4 2 6 6-2 4-4 6-6 6-5 0-9-2-12-6z"/><circle cx="16" cy="12" r="1"/><path d="M22 8l-3 4 3 4"/></svg>,
    NUTS: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><ellipse cx="12" cy="14" rx="6" ry="7"/><path d="M8 7c0-3 2-5 4-5s4 2 4 5"/></svg>,
    PEANUTS: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M12 2c-3 0-5 2-5 5 0 2 1 3 1 5s-1 3-1 5c0 3 2 5 5 5s5-2 5-5c0-2-1-3-1-5s1-3 1-5c0-3-2-5-5-5z"/><path d="M7 12h10"/></svg>,
    CELERY: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M12 22v-10M12 12c-2-4-6-8-4-10s6 2 4 10M12 12c2-4 6-8 4-10s-6 2-4 10M9 22h6"/></svg>,
    CRUSTACEAN: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M12 16c-3 0-5-1-5-3s2-3 5-3 5 1 5 3-2 3-5 3zM7 13l-3-4M17 13l3-4M9 10l-2-5M15 10l2-5M9 16v3M15 16v3"/></svg>,
    SESAME: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><circle cx="12" cy="12" r="4"/><circle cx="12" cy="12" r="1.5"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4"/></svg>,
    MUSTARD: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M10 2h4v4l2 2v12a2 2 0 01-2 2h-4a2 2 0 01-2-2V8l2-2V2z"/><path d="M10 12h4"/></svg>,
    SHELLFISH: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M4 18c0-6 3.5-14 8-14s8 8 8 14"/><path d="M12 4v14M4 18h16M7 10c2 1 3 1 5 0M12 10c2 1 3 1 5 0"/></svg>,
    LUPINS: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M12 22V8M12 8c-3-4-8-3-8 1s5 5 8 3M12 8c3-4 8-3 8 1s-5 5-8 3M12 14c-2-3-6-2-6 1s4 4 6 2M12 14c2-3 6-2 6 1s-4 4-6 2"/></svg>,
    SULFITES: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M8 22h8M12 22V10M7 10h10l-2-6H9L7 10z"/><path d="M10 4l1-2M14 4l-1-2"/></svg>,
  };
  return icons[type] || <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="20" height="20"><path d="M12 9v4M12 17h.01"/><circle cx="12" cy="12" r="10"/></svg>;
};

const ProductModal = ({ setCartModal, id, productDetail }) => {
  const { image: uri } = useGetImages(
    "product_pictures",
    id,
    productDetail?.URUN_KOD
  );
  const modalRef = useRef();
  const [opsiyonlar, setOpsiyonlar] = useState(null);

  useEffect(() => {
    if (!productDetail?.URUN_KOD || !id) return;
    const fetchOps = async () => {
      try {
        const res = await fetch(`${OPSIYON_API}product_options/${id}/${productDetail.URUN_KOD}`);
        const text = await res.text();
        const fixed = text.replaceAll("'", '"');
        const data = JSON.parse(fixed);
        if (Array.isArray(data) && data.length > 0) {
          const portionOpt = data.find(i => String(i.PR_TR) === "2");
          const extraOpt = data.find(i => String(i.PR_TR) === "3");
          const allergenOpt = data.find(i => String(i.PR_TR) === "7");
          const portions = (portionOpt?.DETAIL || []).filter(d => d.DESCRIPTION);
          const extras = (extraOpt?.DETAIL || []).filter(d => d.DESCRIPTION);
          const allergenDetails = allergenOpt?.DETAIL || [];
          const allergens = allergenDetails.filter(a => !isNumericValue(a.DESCRIPTION_ING) && a.DESCRIPTION && !normalizeText(a.DESCRIPTION).includes("yoktur"));
          const nutrition = allergenDetails.filter(a => isNumericValue(a.DESCRIPTION_ING));
          setOpsiyonlar({ portions, extras, allergens, nutrition });
        } else { setOpsiyonlar(null); }
      } catch { setOpsiyonlar(null); }
    };
    fetchOps();
  }, [productDetail?.URUN_KOD, id]);

  const handleModalClose = (e) => {
    if (!modalRef.current.contains(e.target)) setCartModal(false);
  };

  return (
    <div
      onClick={handleModalClose}
      className="z-51 bg-gray-900/70 fixed top-0 left-0 w-full h-full flex justify-center items-center p-4"
      style={{zIndex:51}}
    >
      <div
        ref={modalRef}
        className="w-[90%] flex flex-col md:flex-row justify-between items-center md:items-start max-w-[700px] m-auto p-6 md:p-8 bg-white rounded-lg shadow-2xl max-h-[90vh] overflow-y-auto"
      >
        {uri && (
          <div className="flex-shrink-0 w-full md:w-80">
            <img
              src={uri}
              alt="product image"
              className="object-cover w-full rounded-lg shadow-md"
            />
          </div>
        )}

        <div className="w-full md:ml-5 flex items-center md:items-start flex-col mt-4 md:mt-0">
          <h2 className="text-xl md:text-2xl font-bold text-zinc-800 mb-3 text-center md:text-left">
            {productDetail?.URUN_ADI}
          </h2>
          
          {productDetail?.URUN_ACIKLAMA && (
            <p className="text-zinc-600 text-sm md:text-base leading-relaxed text-center md:text-left mb-4">
              {productDetail?.URUN_ACIKLAMA}
            </p>
          )}

          {productDetail?.FIYATI && (
            <p className="text-lg md:text-xl font-bold text-zinc-800 mb-4">
              {productDetail?.FIYATI} ₺
            </p>
          )}

          {/* Opsiyonlar */}
          {opsiyonlar && (
            <div className="w-full space-y-4 mb-4">
              {opsiyonlar.allergens?.length > 0 && (
                <div>
                  <h4 className="text-xs font-bold text-zinc-700 mb-2 tracking-wide">Alerjenler</h4>
                  <div className="flex flex-wrap gap-2">
                    {opsiyonlar.allergens.map((a, i) => {
                      const type = getAllergenType(a);
                      return (
                        <div key={i} className="flex flex-col items-center gap-1 px-2 py-1.5 rounded-xl bg-red-50 min-w-[60px]">
                          <span className="text-red-500"><AllergenIcon type={type} /></span>
                          <span className="text-[10px] font-semibold text-zinc-500 text-center">{a.DESCRIPTION}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {opsiyonlar.nutrition?.length > 0 && (
                <div>
                  <h4 className="text-xs font-bold text-zinc-700 mb-2 tracking-wide">Besin Değerleri</h4>
                  <div className="space-y-2">
                    {opsiyonlar.nutrition.map((n, i) => {
                      const info = matchNutrition(n.DESCRIPTION);
                      const val = (n.DESCRIPTION_ING || n.DESCRIPTION).replace(",", ".");
                      const numVal = parseFloat(val) || 0;
                      const maxVal = info.unit === "kcal" ? 600 : info.unit === "mg" ? 1000 : 50;
                      const pct = Math.min((numVal / maxVal) * 100, 100);
                      const color = NUTRITION_COLORS[i % NUTRITION_COLORS.length];
                      return (
                        <div key={i}>
                          <div className="flex justify-between text-xs mb-0.5">
                            <span className="font-semibold text-zinc-700">{info.label}</span>
                            <span className="text-zinc-500">{n.DESCRIPTION_ING || n.DESCRIPTION}{info.unit && ` ${info.unit}`}</span>
                          </div>
                          <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                            <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: color }} />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {opsiyonlar.portions?.length > 0 && (
                <div>
                  <h4 className="text-xs font-bold text-zinc-700 mb-2 tracking-wide">Porsiyon Seçenekleri</h4>
                  <div className="flex flex-wrap gap-2">
                    {opsiyonlar.portions.map((p, i) => (
                      <span key={i} className="px-3 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-600">{p.DESCRIPTION}{Number(p.PRICE) > 0 ? ` +${p.PRICE}₺` : ""}</span>
                    ))}
                  </div>
                </div>
              )}
              {opsiyonlar.extras?.length > 0 && (
                <div>
                  <h4 className="text-xs font-bold text-zinc-700 mb-2 tracking-wide">Ekstralar</h4>
                  <div className="flex flex-wrap gap-2">
                    {opsiyonlar.extras.map((e, i) => (
                      <span key={i} className="px-3 py-1 rounded-full text-xs font-medium bg-emerald-50 text-emerald-600">{e.DESCRIPTION}{Number(e.PRICE) > 0 ? ` +${e.PRICE}₺` : ""}</span>
                    ))}
                  </div>
                </div>
              )}

            </div>
          )}

          <button
            onClick={() => setCartModal(false)}
            className="w-full mt-2 bg-[#fecc4c] hover:bg-[#e5b942] transition-colors text-white font-semibold p-3 rounded-lg shadow-md text-sm md:text-base"
          >
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductModal;
